import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Unstable_Grid2 as Grid, Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import SearchResultsSkeletonSegment from '@src/components/SearchResultsSkeletonSegment'

export const useStyles = makeStyles()((theme) => {
  return {
    tRow: {
      display: 'flex',
      alignItems: 'center',
      '& > div': {
        '&:nth-of-type(1)': {
          width: '4%',
        },
        '&:nth-of-type(2)': {
          width: '16%',
        },
        '&:nth-of-type(3)': {
          width: '38%',
        },
        '&:nth-of-type(4)': {
          width: '16%',
        },
        '&:nth-of-type(5)': {
          width: '10%',
        },
        '&:nth-of-type(6)': {
          width: '16%',
        },
        '&:not(:last-of-type)': {
          paddingRight: theme.spacing(5),
        },
      },
    },
    tBodyRow: {
      padding: theme.spacing(2, 0),
      borderBottom: `1px solid ${theme.palette.grey[50]}`,
      '&:first-of-type': {
        borderTop: `1px solid ${theme.palette.grey[50]}`,
      },
    },
    imageContainer: {
      paddingBottom: '100%',
      position: 'relative',
      width: '100%',
      border: `1px solid ${theme.palette.grey[50]}`,
    },
    imageWrapper: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4),
      },
    },
  }
})

const ProductSearchResultsSkeleton = () => {
  const { classes, cx } = useStyles()
  const theme = useTheme()

  return (
    <div data-testid="products-srp-skeleton">
      <Box mb={20} />
      <div>
        {Array(5)
          .fill({})
          .map((_, index) => (
            <Box
              key={index}
              border={1}
              borderColor={theme.palette.grey['50']}
              mb={{ xs: 6, sm: 10 }}
              p={{ xs: 3, sm: 6 }}
            >
              <Grid container spacing={5}>
                <Grid xs={2}>
                  <div className={classes.imageContainer}>
                    <div className={classes.imageWrapper}>
                      <SearchResultsSkeletonSegment height={1} width={1} />
                    </div>
                  </div>
                </Grid>
                <Grid xs={10}>
                  <Box mt={2}>
                    <Grid container spacing={4}>
                      <Grid xs={12}>
                        <SearchResultsSkeletonSegment
                          height={28}
                          width={0.7}
                          mb={3}
                          borderRadius={{ xs: 2, sm: 'borderRadius' }}
                        />
                      </Grid>
                      <Grid xs={4} sm={2}>
                        <SearchResultsSkeletonSegment
                          height={16}
                          width={0.9}
                          borderRadius={{ xs: 2, sm: 'borderRadius' }}
                        />
                      </Grid>
                      <Grid xs={8} sm={10}>
                        <SearchResultsSkeletonSegment
                          height={16}
                          width={0.7}
                          borderRadius={{ xs: 2, sm: 'borderRadius' }}
                        />
                      </Grid>
                      {Array(6)
                        .fill({})
                        .map((_, index) => (
                          <Grid key={index} xs={4} sm={2}>
                            <SearchResultsSkeletonSegment
                              height={16}
                              width={0.6}
                              borderRadius={{ xs: 2, sm: 'borderRadius' }}
                              mb={3}
                            />
                            <SearchResultsSkeletonSegment
                              height={16}
                              width={0.9}
                              borderRadius={{ xs: 2, sm: 'borderRadius' }}
                              mb={{ xs: 1, sm: 3 }}
                            />
                          </Grid>
                        ))}
                    </Grid>
                  </Box>
                </Grid>
                <Grid xs={12}>
                  {Array(3)
                    .fill({})
                    .map((_, index) => (
                      <div
                        key={index}
                        className={cx(classes.tRow, classes.tBodyRow)}
                      >
                        {Array(6)
                          .fill({})
                          .map((_, index) => (
                            <div key={index}>
                              <SearchResultsSkeletonSegment
                                height={16}
                                width={1}
                                borderRadius={{ xs: 2, sm: 'borderRadius' }}
                              />
                            </div>
                          ))}
                      </div>
                    ))}
                </Grid>
              </Grid>
            </Box>
          ))}
      </div>
    </div>
  )
}

export default ProductSearchResultsSkeleton
